const snackbar = {
    namespaced: true,
    mutations: {
        mostrar(state, payload){
            state.texto=payload
        }
    },
    actions: {
        mostrar(state, payload) {
            this.commit('snackbar/mostrar', payload)
        }
    }
}

export default snackbar